import { type ApiClient, type Result, err, isErr, ok } from "../client";
import { BaseService } from "../common/base-service";
import type { Range } from "./types";

export class EmailService extends BaseService {
	constructor(client: ApiClient) {
		super(client, "");
	}

	public async applyCustomDraftEdit(
		draftId: string,
		threadId: string,
		prompt: string,
		range: Range,
	): Promise<Result<void>> {
		const result = await this._client.post(
			"/threads/:threadId/apply_custom_draft_edit",
			{
				params: {
					threadId,
				},
				data: {
					draft_id: draftId,
					field: "body",
					prompt,
					range_start: range[0],
					range_end: range[1],
				},
			},
		);

		if (isErr(result)) {
			return err(result.error);
		}

		return ok(undefined);
	}
}
